// extracted by mini-css-extract-plugin
module.exports = {"userInMenu":"_1Pyi3C3","userName":"DdI8iWg"};